module.exports = "<fes-status [color]=\"color\" [title]=\"title\"></fes-status>\n"